// CatTrax admins: what each role can do at every practice. Practices' own changes still apply on top.
// Laid out like the Settings dialog.
app.component("permissionsAdminConsole", {
	templateUrl: "app/src/js/components/admin/permissionsConsole.html",
	controller: "permissionsAdminController",
});

app.controller("permissionsAdminController", [
	"$q",
	"$state",
	"$stateParams",
	"$window",
	"PermissionAPI",
	"USER_ROLE",
	"toast",
	function ($q, $state, $stateParams, $window, PermissionAPI, USER_ROLE, toast) {
		var $ctrl = this;
		$ctrl.isProcessing = true;

		$ctrl.$onInit = function () {
			$q.all([PermissionAPI.getCatalogue(), PermissionAPI.getRolesEverywhere()])
				.then(function (responses) {
					$ctrl.catalogue = responses[0].data;
					$ctrl.roles = responses[1].data;
					// Opened from the permissions audit log: start on that role, and point out that permission.
					$ctrl.focusPermission = $ctrl.catalogue.find(function (permission) {
						return permission.name === $stateParams.permission;
					}) || null;
					var wanted = $ctrl.roles.find(function (role) {
						return role.role === $stateParams.role;
					});
					if (wanted || $ctrl.roles.length) {
						$ctrl.selectRole(wanted || $ctrl.roles[0]);
					}
				})
				.catch(function (response) {
					toast.create({
						timeout: 8 * 1000,
						message: PermissionAPI.errorMessage(response, "Role permissions could not be loaded."),
						className: "alert-danger",
						dismissible: true,
					});
				})
				.finally(function () {
					$ctrl.isProcessing = false;
				});
		};

		$ctrl.goBack = function () {
			$state.go("welcome");
		};

		$ctrl.roleLabel = function (roleId) {
			if (roleId === "ADMIN") {
				return "CatTrax admin";
			}
			var role = USER_ROLE.find(function (option) {
				return option.id === roleId;
			});
			return role ? role.label : roleId;
		};

		$ctrl.selectRole = function (role) {
			$ctrl.saveStatus = null;
			$ctrl.role = role;
			$ctrl.selected = toSelected(role.permissions);
		};

		// Whether the permission pointed out is ticked for the role shown.
		$ctrl.focusIsTicked = function () {
			return !!($ctrl.focusPermission && $ctrl.selected[$ctrl.focusPermission.name]);
		};

		$ctrl.resetToCodeDefaults = function () {
			$ctrl.selected = toSelected($ctrl.role.starting_permissions);
		};

		$ctrl.save = function () {
			var wanted = Object.keys($ctrl.selected).filter(function (name) {
				return $ctrl.selected[name];
			});
			// Clinical signatures and staff management can't be changed by practices, so a change here
			// is the only one that reaches every practice. Ask before changing one.
			var lockedChanges = $ctrl.catalogue.filter(function (permission) {
				var wasOn = $ctrl.role.permissions.indexOf(permission.name) !== -1;
				return permission.locked_for_practices && wasOn !== !!$ctrl.selected[permission.name];
			});
			if (lockedChanges.length && !$window.confirm("This changes \"" + lockedChanges.map(function (permission) {
				return permission.label;
			}).join("\", \"") + "\" for every " + $ctrl.roleLabel($ctrl.role.role) + " at every practice. Continue?")) {
				return;
			}

			$ctrl.isProcessing = true;
			$ctrl.saveStatus = "Saving...";
			PermissionAPI.saveRoleEverywhere($ctrl.role.role, wanted)
				.then(function (response) {
					var index = $ctrl.roles.indexOf($ctrl.role);
					$ctrl.roles[index] = response.data;
					$ctrl.selectRole(response.data);
					$ctrl.saveStatus = "Saved for every practice";
				})
				.catch(function (response) {
					$ctrl.saveStatus = "Error: " + PermissionAPI.errorMessage(response, "The role could not be saved.");
				})
				.finally(function () {
					$ctrl.isProcessing = false;
				});
		};

		$ctrl.saveFlashClass = function () {
			return {
				saving: $ctrl.saveStatus === "Saving...",
				error: $ctrl.saveStatus && $ctrl.saveStatus.indexOf("Error") === 0,
			};
		};

		$ctrl.saveFlashIcon = function () {
			if ($ctrl.saveStatus === "Saving...") {
				return "fa-circle-o-notch fa-spin";
			}
			return $ctrl.saveStatus.indexOf("Error") === 0 ? "fa-exclamation-circle" : "fa-check-circle";
		};

		function toSelected(names) {
			var selected = {};
			names.forEach(function (name) {
				selected[name] = true;
			});
			return selected;
		}
	},
]);
